import { gql } from '@apollo/client';

export const setInsuranceNumber = gql`mutation setInsuranceNumber($soId: String!, $insuranceNumber: String!) {
  setInsuranceNumber(id: $soId, insuranceNumber: $insuranceNumber)
}`
